import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($window, $scope, PolicyService, CancellationService, $q, $stateParams, $rootScope) {
    var ctrl = Object.create(BaseCtrl);
    $scope.jobNumber = $stateParams.jobNumber;
    console.log($scope.jobNumber);
};

fn.$inject = ['$window', '$scope', 'policy.PolicyService', 'CancellationService', '$q', '$stateParams', '$rootScope'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/EnterPayrollDetailsCtrl.js
// module id = 1671
// module chunks = 0